export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/gift/icon-event-cash-a6aeb1f28ca8ce6df671e822f389d65e.svg";